import { DIGITAL_WELL_BEING_UNIT_LABEL } from './lessonCompletionHelpers'

const emptyGradeRow = name => ({
  name,
  numOfClasses: 0,
  classesNotStarted: 0,
  lessonsCompleted: 0,
  lessonsCompletedPercent: 0,
  totalLessons: 0,
})

const DWB_GRADE_NAMES = [
  'grade-dwb-k',
  'grade-dwb-1',
  'grade-dwb-2',
  'grade-dwb-3',
  'grade-dwb-4',
  'grade-dwb-5',
  'grade-dwb-6',
  'grade-dwb-7',
  'grade-dwb-8',
  'grade-dwb-9',
  'grade-dwb-10',
  'grade-dwb-11',
  'grade-dwb-12',
]

const unitGradeTemplate = () => DWB_GRADE_NAMES.map(emptyGradeRow)

export const defaultDwbGrades = {
  [DIGITAL_WELL_BEING_UNIT_LABEL]: unitGradeTemplate(),
  'Unit 1': unitGradeTemplate(),
  'Unit 2': unitGradeTemplate(),
  'Unit 3': unitGradeTemplate(),
  'Unit 4': unitGradeTemplate(),
}
